import React, { Component } from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash.debounce'
import { InputField, ImageInput } from '@/ui/Input'
import SelectField from './SelectField'
import ImageField from '@/ui/Data/ImageField'
import linktypes from '@/helpers/linkTypes'

const cap = string => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

class Edit extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    debounce: PropTypes.number.isRequired,
  }

  static defaultProps = {
    debounce: 500,
  }

  componentWillUnmount() {
    if (this.props.debouncedChange) {
      this.debouncedChange.cancel()
    }
  }

  debouncedChange = debounce((item, type, value) => {
    this.props.onChange(item, type, value)
  }, this.props.debounce)

  render() {
    const { item, newsletterId, current, theme } = this.props
    return (
      <div className="form" key={item.type + item.id}>
        <Choose>
          <When
            condition={item.type === 'Card / Text only' || item.type === 'Card / Text only + CTA'}
          >
            <If condition={item.type == 'Card / Text only + CTA'}>
              <InputField
                id="buttontext"
                theme={theme}
                key={`buttontext${item.id}`}
                name="buttontext"
                labelText="Button text"
                defaultValue={item.buttontext}
                onChange={(e, value) => this.props.onChange(item, 'buttontext', value)}
              />
              <InputField
                id="buttonlink"
                theme={theme}
                key={`buttonlink${item.id}`}
                name="buttonlink"
                labelText="Button link"
                defaultValue={item.buttonlink}
                onChange={(e, value) => this.props.onChange(item, 'buttonlink', value)}
              />
            </If>
          </When>
          <When condition={item.type == 'Card / Image'}>
            <div className={theme['form-group']}>
              <label>Image</label>
              <div style={{ position: 'relative', minHeight: '115px' }}>
                <ImageInput
                  id="image"
                  theme={this.props.theme}
                  source="image"
                  label="Image"
                  accept="image/*"
                  key={`img${item.id}`}
                  input={{
                    value: item.image
                      ? item.image.src
                        ? item.image.src
                        : `newsletters/${String(newsletterId).padStart(4, '0')}/${item.image}`
                      : null,
                    onChange: v =>
                      this.props.onChange(item, 'image', (Array.isArray(v) && v[0]) || null),
                  }}
                  placeholder={<p>Drop your image here</p>}
                >
                  <ImageField source="src" title="title" />
                </ImageInput>
              </div>
            </div>
            <InputField
              id="imageurl"
              theme={theme}
              key={`imageurl${item.id}`}
              name="imageurl"
              labelText="Image URL"
              defaultValue={item.imageurl}
              onChange={(e, value) => this.props.onChange(item, 'imageurl', value)}
            />
          </When>
          <When
            condition={
              item.type == 'Card / Image + Text' || item.type == 'Card / Image + Text (no CTA)'
            }
          >
            <div className={theme['form-group']}>
              <label>Image</label>
              <div style={{ position: 'relative', minHeight: '115px' }}>
                <ImageInput
                  id="image"
                  theme={this.props.theme}
                  source="image"
                  label="Image"
                  accept="image/*"
                  key={`img${item.id}`}
                  cta={item.type == 'Card / Image + Text'}
                  input={{
                    value: item.image
                      ? item.image.src
                        ? item.image.src
                        : `newsletters/${String(newsletterId).padStart(4, '0')}/${item.image}`
                      : null,
                    onChange: v =>
                      this.props.onChange(item, 'image', (Array.isArray(v) && v[0]) || null),
                  }}
                  placeholder={<p>Drop your image here</p>}
                >
                  <ImageField source="src" title="title" />
                </ImageInput>
              </div>
            </div>
            <InputField
              id="imageurl"
              theme={theme}
              key={`imageurl${item.id}`}
              name="imageurl"
              labelText="Image URL"
              defaultValue={item.imageurl}
              onChange={(e, value) => this.props.onChange(item, 'imageurl', value)}
            />
            <If condition={item.type == 'Card / Image + Text'}>
              <InputField
                id="buttontext"
                theme={theme}
                key={`buttontext${item.id}`}
                name="buttontext"
                labelText="Button text"
                defaultValue={item.buttontext}
                onChange={(e, value) => this.props.onChange(item, 'buttontext', value)}
              />
              <InputField
                id="buttonlink"
                theme={theme}
                key={`buttonlink${item.id}`}
                name="buttonlink"
                labelText="Button link"
                defaultValue={item.buttonlink}
                onChange={(e, value) => this.props.onChange(item, 'buttonlink', value)}
              />
            </If>
          </When>
          <When
            condition={[
              'Card / Akademie',
              'Card / Akademie custom',
              'Card / Akademie + header',
            ].includes(item.type)}
          >
            <If condition={item.type == 'Card / Akademie + header'}>
              <div className={theme['form-group']}>
                <label>Image</label>
                <div style={{ position: 'relative', minHeight: '115px' }}>
                  <ImageInput
                    id="image"
                    theme={this.props.theme}
                    source="image"
                    label="Image"
                    accept="image/*"
                    key={`img${item.id}`}
                    cta={item.type == 'Card / Akademie + header'}
                    input={{
                      value: item.image
                        ? item.image.src
                          ? item.image.src
                          : `newsletters/${String(newsletterId).padStart(4, '0')}/${item.image}`
                        : null,
                      onChange: v =>
                        this.props.onChange(item, 'image', (Array.isArray(v) && v[0]) || null),
                    }}
                    placeholder={<p>Drop your image here</p>}
                  >
                    <ImageField source="src" title="title" />
                  </ImageInput>
                </div>
              </div>
              <InputField
                id="imageurl"
                theme={theme}
                key={`imageurl${item.id}`}
                name="imageurl"
                labelText="Image URL"
                defaultValue={item.imageurl}
                onChange={(e, value) => this.props.onChange(item, 'imageurl', value)}
              />
            </If>
            <div className={theme.splitted}>
              <InputField
                id="items"
                theme={theme}
                key={`items-${current}-${item.id}`}
                name="items"
                labelText="Items"
                defaultValue={(item.data && item.data.length) || 0}
                onChange={(e, value) => this.props.onChange(item, 'numItems', value)}
              />
              <SelectField
                id="current"
                theme={theme}
                key={`select-${current}-${item.id}`}
                name="current"
                labelText="Edit item"
                prefix="Item"
                value={current | 0}
                items={(item.data && item.data.length) || 0}
                onChange={(e, value) => this.props.onChange(item, 'current', value)}
              />
            </div>
            <hr />
            <If
              condition={
                item.data && Array.isArray(item.data) && !isNaN(current) && item.data[current]
              }
            >
              <With element={item.data[current]}>
                <InputField
                  id="buttontext"
                  theme={theme}
                  key={`bt-${current}-${item.id}`}
                  name="buttontext"
                  labelText="Button text"
                  value={element['buttontext'] || ''}
                  onChange={(e, value) => this.props.onChange(item, [current, 'buttontext'], value)}
                />
                <InputField
                  id="buttonlink"
                  theme={theme}
                  key={`bl-${current}-${item.id}`}
                  name="buttonlink"
                  labelText="Button link"
                  value={element['buttonlink'] || ''}
                  onChange={(e, value) => this.props.onChange(item, [current, 'buttonlink'], value)}
                />
              </With>
            </If>
          </When>
          <When
            condition={item.type === 'Card / Infothek' || item.type === 'Card / Infothek + Icons'}
          >
            <div className={theme.splitted}>
              <InputField
                id="items"
                theme={theme}
                key={`items${item.id}`}
                name="items"
                labelText="Items"
                defaultValue={(item.data && item.data.length) || 0}
                onChange={(e, value) => this.props.onChange(item, 'numItems', value)}
              />
              <SelectField
                id="current"
                theme={theme}
                key={`current${item.id}`}
                name="current"
                labelText="Edit item"
                prefix="Item"
                value={current | 0}
                items={(item.data && item.data.length) || 0}
                onChange={(e, value) => this.props.onChange(item, 'current', value)}
              />
            </div>
            <hr />
            <If
              condition={
                item.data && Array.isArray(item.data) && !isNaN(current) && item.data[current]
              }
            >
              <With element={item.data[current]}>
                <If condition={item.type === 'Card / Infothek + Icons'}>
                  <div className={theme['form-group']}>
                    <label>Link type</label>
                    <select
                      data-i={JSON.stringify(item)}
                      key={`lt${current}${item.id}`}
                      name="linktype"
                      defaultValue={element.linktype}
                      onChange={e =>
                        this.props.onChange(item, [current, 'linktype'], e.target.value)}
                    >
                      <For each="item" index="indx" of={linktypes}>
                        <option key={indx} value={linktypes[indx]}>
                          {cap(linktypes[indx])}
                        </option>
                      </For>
                    </select>
                  </div>
                </If>
                <InputField
                  id="linktext"
                  theme={theme}
                  key={`lt${current}${item.id}`}
                  name="linktext"
                  labelText="Link text"
                  defaultValue={element['linktext']}
                  onChange={(e, value) => this.props.onChange(item, [current, 'linktext'], value)}
                />
                <InputField
                  id="linkurl"
                  theme={theme}
                  key={`lu${current}${item.id}`}
                  name="linkurl"
                  labelText="Link url"
                  defaultValue={element['linkurl']}
                  onChange={(e, value) => this.props.onChange(item, [current, 'linkurl'], value)}
                />
              </With>
            </If>
          </When>
        </Choose>
      </div>
    )
  }
}

export default Edit



// WEBPACK FOOTER //
// ./ui/Blocks/Edit.js